import { render, staticRenderFns } from "./BackPostSingleCrochetIcon.vue?vue&type=template&id=67b351b5&scoped=true"
import script from "./BackPostSingleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./BackPostSingleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./BackPostSingleCrochetIcon.vue?vue&type=style&index=0&id=67b351b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b351b5",
  null
  
)

export default component.exports